/* eslint-disable max-lines */
/* eslint-disable max-statements */
import { Form } from "antd"
import { useState } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { Constant } from "../../../../../../../constant"
import { Routers } from "../../../../../../../constant/Routers"
import { getUserInformation } from "../../../../../../../utils/getUserInformation"
import {
  SchedulesListDataType,
  SchedulesListStateType,
  SchedulesSearchConditionType,
} from "../../../../models/list"
import { useRowSelection } from "../useRowSelection"
import { OptionItemType } from "../../../../../../../_webui/layout/components/Select/models"
import { GeneralMastersResType } from "../../../../../../../infrastructure/handlers/generalMasters/models"
import { SchedulesSearchFormDataType } from "../../../../models/list/search"
import { useModal } from "../../../../../../../utils/hook/useModal"

const { CHECK_SELECTED_LANG } = Constant
const { SCR210_ATTENTIONS, SCR210_SAFETIES, SCR210 } = Routers

export const useVariablesApi = (isRoleSubAdmin: boolean) => {
  const [form] = Form.useForm<SchedulesSearchFormDataType>()
  const { state, pathname } = useLocation<SchedulesListStateType>()
  const { push } = useHistory()

  const {
    isOpen: isOpenEmptySearchCondition,
    onCancel: handleCancelEmptySearchCondition,
    onOpen: handleOpenEmptySearchCondition,
  } = useModal()

  const [isLoadingTable, setIsLoadingTable] = useState(false)
  const [isLoadingLayout, setIsLoadingLayout] = useState(true)
  const [isResetTable, setIsResetTable] = useState(false)
  const [countries, setCountries] = useState<OptionItemType[]>([])
  const [arrivalCities, setArrivalCities] = useState<OptionItemType[]>([])
  const [dispatchTypeAll, setDispatchTypeAll] = useState<
    GeneralMastersResType[]
  >([])
  const [dispatchType, setDispatchType] = useState<OptionItemType[]>([])
  const [dispatchTypeDetail, setDispatchTypeDetail] = useState<
    OptionItemType[]
  >([])
  const [isDisabledDispatchTypeDetail, setIsDisabledDispatchTypeDetail] =
    useState(true)
  const [purposeTravel, setPurposeTravel] = useState<OptionItemType[]>([])
  const [searchCondition, setSearchCondition] = useState<
    SchedulesSearchConditionType | undefined
  >(state?.searchCondition)
  const [dataSource, setDataSource] = useState<SchedulesListDataType[]>([])
  const [travelerId, setTravelerId] = useState("")
  const [departments, setDepartments] = useState<OptionItemType[]>([])

  const userInformation = getUserInformation()
  const isPathnameSchedules = pathname === SCR210
  const isPathnameAttentionsOrSafeties =
    pathname === SCR210_ATTENTIONS || pathname === SCR210_SAFETIES

  const {
    dataSourceSelected,
    handleSetDefaultSortedInfo,
    isDisabledBtnCreateOrSend,
    isDisabledBtnDelete,
    isDisabledBtnRefer,
    onChange,
    onChangeTable,
    perItem,
    rowSelection,
    selectedRowKeys,
    sortedInfo,
    travelScheduleId,
  } = useRowSelection(dataSource, isRoleSubAdmin)

  const fullName = CHECK_SELECTED_LANG
    ? userInformation?.fullNameKanji || userInformation?.fullNameRomaji
    : userInformation?.fullNameRomaji

  return {
    arrivalCities,
    countries,
    dataSource,
    dataSourceSelected,
    departments,
    dispatchType,
    dispatchTypeAll,
    dispatchTypeDetail,
    form,
    fullName,
    handleCancelEmptySearchCondition,
    handleOpenEmptySearchCondition,
    handleSetDefaultSortedInfo,
    isDisabledBtnCreateOrSend,
    isDisabledBtnDelete,
    isDisabledBtnRefer,
    isDisabledDispatchTypeDetail,
    isLoadingLayout,
    isLoadingTable,
    isOpenEmptySearchCondition,
    isPathnameAttentionsOrSafeties,
    isPathnameSchedules,
    isResetTable,
    onChange,
    onChangeTable,
    pathname,
    perItem,
    purposeTravel,
    push,
    rowSelection,
    searchCondition,
    selectedRowKeys,
    setArrivalCities,
    setCountries,
    setDataSource,
    setDepartments,
    setDispatchType,
    setDispatchTypeAll,
    setDispatchTypeDetail,
    setIsDisabledDispatchTypeDetail,
    setIsLoadingLayout,
    setIsLoadingTable,
    setIsResetTable,
    setPurposeTravel,
    setSearchCondition,
    setTravelerId,
    sortedInfo,
    state,
    travelScheduleId,
    travelerId,
    userInformation,
  }
}
